import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            <span>Dangerous Goods Declaration</span>{' '}
            <span>Forms and Templates</span>
          </h1>
          <p className={cn('header__heading-description')}>
            The Dangerous Goods Declaration (DGD) is where regulatory compliance meets the reality of
            transport. It is effectively a mandatory certification telling the carrier, "I have packed, labeled,
            and declared these{' '}
            <Link href='/freight-dictionary/hazardous-materials'>hazardous materials</Link>{' '} 
            exactly according to the code." In our line of work, a
            typo here isn't just an administrative error; it’s a safety risk that can ground an aircraft or stop a
            vessel in its tracks.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;